import React from 'react';
import { useAuth } from '../AuthProvider';
import AuthService from '../../../services/AuthService';
import './ProtectedRoute.css';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, isAdmin, isCreator, hasRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-spinner-container">
        <div className="loading-spinner"></div>
        <p>Chargement de l'authentification...</p>
      </div>
    );
  }

  if (!isAuthenticated()) {
    // Rediriger vers le SSO de l'app principale
    AuthService.redirectToLogin();
    return (
      <div className="loading-spinner-container">
        <div className="loading-spinner"></div>
        <p>Redirection vers la connexion...</p>
      </div>
    );
  }

  // Verification du role admin
  if (requiredRole === 'admin' && !isAdmin()) {
    return (
      <div className="access-denied">
        <h2>Accès refusé</h2>
        <p>Vous n'avez pas les droits d'administration nécessaires.</p>
        <button onClick={() => window.history.back()}>Retour</button>
      </div>
    );
  }

  // Verification du role creator
  if (requiredRole === 'creator' && !isCreator()) {
    return (
      <div className="access-denied">
        <h2>Accès refusé</h2>
        <p>Vous devez être un créateur avec une boutique active pour accéder à cette page.</p>
        <div className="access-denied-actions">
          <button onClick={() => window.history.back()}>Retour</button>
          <a href="/become-creator" className="become-creator-link">
            Devenir créateur
          </a>
        </div>
      </div>
    );
  }

  // Verification generique pour tout autre role
  if (
    requiredRole &&
    requiredRole !== 'admin' &&
    requiredRole !== 'creator' &&
    !hasRole(requiredRole)
  ) {
    return (
      <div className="access-denied">
        <h2>Accès refusé</h2>
        <p>Vous n'avez pas les droits nécessaires pour accéder à cette page.</p>
        <button onClick={() => window.history.back()}>Retour</button>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
